import { Typography } from '@mui/joy';
import { PencilSimpleLine } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';

import { getAgGridTableCellData } from 'core/utils';
import { QuotePartColId } from 'quotes/components/QuotePartList';
import { IQuotePart } from 'quotes/types';
import { Color, Level } from 'theme/enums';

interface IProps extends ICellRendererParams {
  onEditPartLineClick?: (quotePart: IQuotePart) => void;
  isRowEditable?: ({ data }) => boolean;
}

export const EditLineCell = ({ onEditPartLineClick, isRowEditable, ...props }: IProps) => {
  // Action-only column: group rows resolve to no data and get no affordance.
  const data = getAgGridTableCellData(props, QuotePartColId.EDIT_LINE);

  if (!data || !isRowEditable?.({ data })) {
    return null;
  }

  return (
    <Typography
      color={Color.PRIMARY}
      level={Level.BODY_SM}
      onClick={onEditPartLineClick ? () => onEditPartLineClick(data) : undefined}
      sx={{ cursor: 'pointer' }}
    >
      <PencilSimpleLine />
    </Typography>
  );
};
